import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';
import loader from '../../assets/images/loading.gif';
import '../../styles/home.css';

function TrackConversionPage() {
    const history = useHistory();

    const [authCookie, setAuthCookie, removeAuthCookie] = useCookies([
        'access_token',
        'oauth_token'
    ]);

    const [eligible, setEligible] = useState(false);

    let conversionScript =
        "!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);},s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');twq('init','o7iqv');twq('track','PageView');";

    useEffect(() => {
        let i = 0;
        // Authorized
        if (authCookie?.access_token && authCookie?.oauth_token) {
            // setEligible to true - Run the conversionScript
            setEligible(true);
            const interval = setInterval(async () => {
                history.push('/survey');

                i += 1;
                if (i === 1) {
                    clearInterval(interval);
                }
            }, 100);
        }
        // Unauthorized, so Logout
        else {
            history.push('/');
            removeAuthCookie('oauth_token');
            removeAuthCookie('access_token');
            localStorage.removeItem('twclid');
            localStorage.removeItem('return_token');
        }
    }, []);

    return (
        <Container>
            <Helmet>{eligible && <script>{conversionScript}</script>}</Helmet>

            <div className="blur-screen">
                <img src={loader} alt="preview" className="loader-image" />
            </div>
        </Container>
    );
}

export default TrackConversionPage;
